/***********************************************************************
Use            : Helper class to tranform db entity to vue model and trnasform back
Created By     : ATP-0000850
Created Date   : 11-AUG-2020
Updated By     : ATP-0000850
Updated Date   : 11-AUG-2020
***********************************************************************/
import * as _ from 'lodash';
import { i18n } from "@/plugins/i18n";

export class AppTransformers {

    /** method to transform project monitoring plan model to db entity */
    static transformPMPModel(datum: any, sites: any) {
        
        var output: Array<any> = [];

        const indicatorMappings = datum.indicators;
        const data = datum.data;
        const siteInfo = _.cloneDeep(sites) || [];

        if(indicatorMappings && Object.keys(indicatorMappings).length > 0 ) {
            Object.keys(indicatorMappings).forEach((resultId: string) => {
                // #. check if data exists for the result id
                if(data && data[resultId]) {
                    const indicators = indicatorMappings[resultId];
                    if(indicators && indicators.length > 0) {
                        indicators.forEach( (indicator) => {
                            if(indicator.Children && indicator.Children.length > 0) {
                                // #. if children exists, call the recursive fn to get the child record
                                var parentObj = {
                                    resultId,
                                    "indicatorId": indicator.ID,
                                    "indicatorName": indicator.Description
                                };
                                indicator.Children.forEach((child) => {
                                    this.getSUbProps(data[resultId][indicator.ID], child, output, parentObj);
                                });
                            } else {
                                if(data[resultId][indicator.ID]) {
                                    output.push({
                                        resultId,
                                        "indicatorId": indicator.ID,
                                        "indicatorName": indicator.Description,
                                        "target": data[resultId][indicator.ID].target,
                                        "baseline": data[resultId][indicator.ID].baseline,
                                        "baselineunknown": data[resultId][indicator.ID].baselineunknown
                                    });
                                }
                            }
                        })
                    }
                }         
            });
        }
        
        let finalResp = output.filter(o1 => o1.site ? siteInfo.some(o2 => o1.site === o2.name) : output); // filter and save indicators corresponding to sites
        return finalResp;
    }

    /** method to transform db entity to PMP model */
    static transformPMPDbEntity(datum: any, indicators: any) {
        let data = {};
        let mapping = {};
        if(datum && datum.length > 0) {
            const  results = _.uniq(datum.map(x => x.resultId));
            results.forEach((resultId: any) => {

                mapping[resultId] = [];
                data[resultId] = {};

                const mappedIndicators = _.uniq (datum
                .filter( (x: any) => x.resultId === resultId )
                .map( (x: any) => x.indicatorId ));

                mapping[resultId] = indicators.filter((x:any) => {
                   return mappedIndicators.includes(x.ID)
                });

            });
            datum.forEach((x: any) => {
                if(x.indicatorId) {
                    if(!data[x.resultId][x.indicatorId]) {
                        data[x.resultId][x.indicatorId] = {};
                    }
                }
                if(x.site) {
                    if(!data[x.resultId][x.indicatorId][x.site]) {
                        data[x.resultId][x.indicatorId][x.site] = {}; 
                    }
                    if(x.measureId) {
                        if(!data[x.resultId][x.indicatorId][x.site][x.measureId]) {
                            data[x.resultId][x.indicatorId][x.site][x.measureId] = {}; 
                        }
                        if(x.optionId) {
                            if(!data[x.resultId][x.indicatorId][x.site][x.measureId]['levels']) {
                                data[x.resultId][x.indicatorId][x.site][x.measureId]['levels'] = [];
                            }
    
                            data[x.resultId][x.indicatorId][x.site][x.measureId]['levels'].push({
                                "ID": x.optionId,
                                "target": x.target,
                                "baseline": x.baseline,
                                "baselineunknown": x.baselineunknown
                            });
                        } else {
                            data[x.resultId][x.indicatorId][x.site][x.measureId].target = x.target;
                            data[x.resultId][x.indicatorId][x.site][x.measureId].baseline = x.baseline;
                            data[x.resultId][x.indicatorId][x.site][x.measureId].baselineunknown = x.baselineunknown
                        }
                    } else {
                        data[x.resultId][x.indicatorId][x.site].target = x.target;
                        data[x.resultId][x.indicatorId][x.site].baseline = x.baseline;
                        data[x.resultId][x.indicatorId][x.site].baselineunknown = x.baselineunknown;
                    }
                }
                if(x.measureId) {
                    if(!data[x.resultId][x.indicatorId][x.measureId]) {
                        data[x.resultId][x.indicatorId][x.measureId] = {}; 
                    }
                    if(x.optionId) {
                        if(!data[x.resultId][x.indicatorId][x.measureId]['levels']) {
                            data[x.resultId][x.indicatorId][x.measureId]['levels'] = [];
                        }

                        data[x.resultId][x.indicatorId][x.measureId]['levels'].push({
                            "ID": x.optionId,
                            "target": x.target,
                            "baseline": x.baseline,
                            "baselineunknown": x.baselineunknown
                        });
                    } else {
                        data[x.resultId][x.indicatorId][x.measureId].target = x.target;
                        data[x.resultId][x.indicatorId][x.measureId].baseline = x.baseline;
                        data[x.resultId][x.indicatorId][x.measureId].baselineunknown = x.baselineunknown;
                    }
                } else {
                    data[x.resultId][x.indicatorId].target = x.target;
                    data[x.resultId][x.indicatorId].baseline = x.baseline;
                    data[x.resultId][x.indicatorId].baselineunknown = x.baselineunknown;
                }
            })
        }

        return Object.assign({}, { data, mapping });
    }

    static getSUbProps(data: any, prop: any, output: Array<any>, parentObj: any) {
        switch(prop.Type) {
            case 'site': 
                Object.keys(data).forEach((site: any) => {
                    if(prop.Children) {
                        prop.Children.forEach((child) => {
                            this.getSUbProps(
                                data[site], 
                                child, 
                                output, 
                                Object.assign( {}, parentObj, {
                                    "site": site
                                })
                            );
                        });
                    }
                })
            break;
            case 'measure': 
                if(prop.Children) {
                    prop.Children.forEach((child) => {
                        this.getSUbProps(
                            data[prop.ID], 
                            child, 
                            output, 
                            Object.assign( {}, parentObj, {
                                "measureId": prop.ID,
                                "measureName": prop.Description
                            })
                        );
                    })
                } else {
                    if(data[prop.ID]) {
                        output.push( Object.assign( {}, parentObj, { 
                            "measureId": prop.ID,
                            "measureName": prop.Description,
                            "target": data[prop.ID].target,
                            "baseline": data[prop.ID].baseline,
                            "baselineunknown": data[prop.ID].baselineunknown
                        }))
                    }
                    
                }
            break;
            case 'array': 
                if(data && data['levels'] && data['levels'].length > 0) {
                    data['levels'].forEach((item) => {
                        output.push( Object.assign({}, parentObj, {
                            "optionId": item.ID,
                            "target": item.target,
                            "baseline": item.baseline,
                            "baselineunknown": item.baselineunknown
                        }))                        
                    })                    
                }
            break;
        }        
    }

    /** transforms project timeline to flat structure for saving */
    static transformTimelineModel(data: any) {
        let output: Array<any> = [], deliverable: any, activity: any, years: any;
        if(data && Object.keys(data).length > 0 ) {
            
            Object.keys(data).forEach((resultId: string) => {
                if(data[resultId] && Object.keys(data[resultId]).length > 0) {
                    deliverable = data[resultId];
                    
                    Object.keys(deliverable).forEach((deliverableId: string) => {
                        if(deliverable[deliverableId] && Object.keys(deliverable[deliverableId]).length > 0) {
                            activity = deliverable[deliverableId];
                            
                            Object.keys(activity).forEach((activityId: string) => {
                                if(activity[activityId] && Object.keys(activity[activityId]).length > 0) {
                                    years = activity[activityId];

                                    Object.keys(years).forEach((yr: string) => {
                                        if(years[yr] && Object.keys(years[yr]).length > 0) {
                                            let timeFrame = years[yr];

                                            Object.keys(timeFrame).forEach((tf: string) => {
                                                output.push({
                                                    resultId,
                                                    deliverableId,
                                                    activityId,
                                                    year: yr,
                                                    timeFrame: tf,
                                                    value: timeFrame[tf]
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
        return output;
    }

    /** transforms project timeline to nested structure for template binding */
    static transformTimelineDbEntity(data: any) {
        let model = {};
        if(data && data.length > 0) {
            const results: any[] = _.uniq(data.map((x: any) => x.resultId));
            const yearList: any[] = _.uniq(data.map((x: any) => x.year));
            results.forEach((resultId: any) => {
                model[resultId] = {};
                const del: any[] = _.uniq(data
                    .filter((r: any) => r.resultId === resultId)
                    .map((x: any) => x.deliverableId));

                del.forEach((deliverableId: any) => {
                    model[resultId][deliverableId] = {};
                    const act: any[] = _.uniq(data
                        .filter((r: any) => r.resultId === resultId && r.deliverableId === deliverableId)
                        .map((x: any) => x.activityId));
                    
                    act.forEach((activityId: any) => {
                        model[resultId][deliverableId][activityId] = {};
                        // #. assign empty object to all years
                        yearList.forEach((y: any) => {
                            model[resultId][deliverableId][activityId][y] = {};
                        });
                        const years: any[] = _.uniq(data
                            .filter((r: any) => r.resultId === resultId && r.deliverableId === deliverableId && r.activityId === activityId)
                            .map((x: any) => x.year));

                        years.forEach((yr: any) => {
                            const timeframe: any[] = _.uniq(data
                                .filter((r: any) => r.resultId === resultId && r.deliverableId === deliverableId && r.activityId === activityId && r.year === yr)
                                .map((x: any) => x.timeFrame));

                            timeframe.forEach((tf: any) => {
                                const values: any[] = _.uniq(data
                                    .filter((r: any) => r.resultId === resultId && r.deliverableId === deliverableId && r.activityId === activityId && r.year === yr && r.timeFrame === tf));
                                // #. assign data to model
                                model[resultId][deliverableId][activityId][yr][tf] = values[0].value;
                            });
                        });
                        
                    });
                });
            });
        }
        return model;
    }

    /** transform budget entity */
    static transformBudgetDBEntity(data: any, schema: any) {

        let budgetData: any = {};

        const reservedKeys = ['descr', 'activityCode', 'details', 'matchFunding', 'budgetProportions', 'detail_expl'];

        if (data) {

            budgetData.categories = schema.properties[0].default;

            budgetData.series = data.series;

            const { data_row, summary } = data;

            // #. parse the data rows
            if (data_row && data_row.length > 0) {

                // #. make it key value properties from array of props
                budgetData.data = data_row.reduce((result, lineItem) => {

                    const key = lineItem["category_id"];

                    if (!result[key]) {
                        result[key] = [];
                    }

                    // #. parse the series column
                    const row = Object.keys(lineItem).reduce((out, item) => {

                        if (item === 'series_data') {
                            lineItem['series_data'].forEach((series) => {
                                out[series.key] = series;
                                delete series.key;
                            })
                        } else if (reservedKeys.includes(item)) {
                            out[item] = lineItem[item]
                        }
                        return out;
                    }, {});

                    // check and fill the missing series..
                    budgetData.series.forEach((series) => {
                        if(!row[series.name]) {
                            row[series.name] = {};
                        }
                    });

                    result[key].push(row);

                    return result;

                }, {});
            } else {
                budgetData.data = {};
            }

            /** add default value for the missing categories */
            budgetData.categories.forEach((catg) => {
                if(!budgetData.data[catg.id]) {
                    budgetData.data[catg.id] = [];
                }
            });

            /*** summary section */
            budgetData.summary = {};

            if(schema['x-subtotals']) {
                budgetData.summary.subtotals = {};

                if(summary && summary.subtotals && summary.subtotals.length > 0 ) {

                    // #. get the sub total line items
                    summary.subtotals.forEach((subtotal) => {

                        let subTotalProp = {};

                        Object.keys(subtotal).forEach((key) => {
                            if(key === 'series_data') {
                                subtotal[key].forEach((total) => {
                                    subTotalProp[total.key] = total;
                                });                                  

                            } else {
                                subTotalProp[key] = subtotal[key];
                            }
                        });
                        // check and fill the missing series..
                        budgetData.series.forEach((series) => {
                            if(!subTotalProp[series.name]) {
                                subTotalProp[series.name] = {};
                            }
                        });

                        budgetData.summary.subtotals[subtotal["category_id"]] = subTotalProp;
                    })
                } else {
                    // #. set default value if not exists
                    budgetData.summary.subtotals = budgetData.categories.reduce((obj, item) => {
                        if(!obj[item.id]){

                            obj[item.id] = {};
                            obj[item.id]['descr'] = `${i18n.t('Sub Total')}`;

                            budgetData.series.forEach((series) => {
                                obj[item.id][series.name] = {};
                            });                                
                        }
                        return obj;
                    }, {});
                }

                // #. get the budget data properties
                Object.keys(schema.properties[3].properties).forEach((summaryKey) => {
                    budgetData.summary[summaryKey] = {};
                    if(summary && summary[summaryKey] && summary[summaryKey].length > 0) {
                        summary[summaryKey].forEach((item) => {
                            //Object.keys()
                            budgetData.summary[summaryKey][item.series] = item;
                            delete budgetData.summary[summaryKey][item.series].series;
                        })
                    } else {
                        budgetData.series.forEach((series) => {
                            budgetData.summary[summaryKey][series.name] = {};
                        });   
                    }                        
                });

                if(summary) {
                    /** update the non series columns */
                    Object.keys(summary)
                    .filter(x => reservedKeys.includes(x))
                    .forEach((x) => {
                        if(summary[x] && summary[x].length > 0) {
                            summary[x].forEach((info) => {
                                budgetData.summary[info.item][x] = info.value;
                            });
                        }                        
                    });
                }
            }
        }
        return budgetData;

    }

}
